<template>
  <div class="index">
    <div class="headTitle">
      <div class="banner" style="height: 18rem"></div>
      <div class="userInfo">
        <div class="userInfo_title">岗 位</div>
        <div class="userInfo_update">
        </div>
        <div class="userInfo_content">
          <div class="userInfo_icon" v-show="src != null">
            <img :src=src alt="">
          </div>
          <div class="userInfo_right">
            <div class="userInfo_line">
              <div class="userInfo_str">姓 名：<span></span></div>
              <div class="userInfo_val">{{ userinfo.name }}<span></span></div>
            </div>
            <div class="userInfo_line">
              <div class="userInfo_str">岗 位<span></span></div>
              <div class="userInfo_val">{{ showdepartment() }}<span></span></div>
            </div>
            <!-- <div class="userInfo_line">
              <div class="userInfo_str">学 时<span></span></div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="menuContent">
      <keep-alive>
        <!-- 保存数据方法 -->
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <!-- 不保存数据方法 -->
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
  </div>
</template>
<script>
// import * as req from '@/utils/request'
import * as req from '@/utils/request'

export default {
  data () {
    return {
      userinfo: {
        name: '',
        user_img: null
      }
    }
  },
  computed: {
    src () {
      let userImg = this.userinfo.user_img
      if (userImg == null) {
        return null
      }
      let iconUrl = this.global.iconUrl
      return iconUrl + userImg
    }
  },
  mounted () {
    this.getToken()
  },
  methods: {
    showdepartment () {
      let result = ''
      let user = this.global.user_info
      if (!user.branch_id) {
        return ''
      }
      let obj = this.global.optionsList
      for (let i in obj) {
        if (obj[i].value === user.branch_id) {
          result = (obj[i].label) + '/'
          let arr = obj[i].children
          for (let s in arr) {
            if (arr[s].value === user.station_id) {
              return result.concat(arr[s].label)
            }
          }
        }
      }
      return '--'
    },
    getToken () {
      let url = window.location.href
      let index = url.indexOf('?')
      if (index === -1) {
        // window.location.href = this.global.loginURL
      }
      let token = url.substring(index + 1, url.length)
      token = token.replace('#/', '')
      // this.global.token = token
      this.getUserData(token)
    },
    getUserData (token) {
      let msg = {}
      msg.token = token
      let sendData = {}
      sendData.data = msg
      sendData.fn = this.getUserDatafn
      sendData.vm = this
      req.Post('user/analy_token', sendData)
    },
    getUserDatafn (data) {
      if (data.err_code !== 0) {
        alert(data.err_msg)
        return
      }
      this.userinfo = data.list
    }
  }
}
</script>

<style scoped>
.headTitle {
  width: 100%;
  height: 33%;
  display: flex;
  /* border: 1px solid; */
}

.banner {
  width: 75%;
  height: 100%;
  background-image: url(../assets/bg/banan.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  -o-background-size: cover;
}

.userInfo {
  width: 560px;
}

.userInfo_title {
  height: 20%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
}

.userInfo_content {
  height: 70%;
  width: 90%;
  margin: auto;
  display: flex;
}

.userInfo_right {
  width: 56%;
  margin: auto;
}

.userInfo_update {
  margin-left: 25rem;
}

.userInfo_icon {
  width: 40%;
  margin-right: 15px;
  border: 1px solid rgb(167, 167, 167);
}

.userInfo_icon > img {
  width: 100%;
  height: 100%;
}

.userInfo_line {
  height: 40px;
  align-items: center;
  display: flex;
}

.userInfo_str {
  width: 30%;
  text-align: justify;
}

.userInfo_val {
  /* margin-left: 30%; */
  width: 100%;
  text-align: center;
}

.userInfo_val > span {
  display: inline-block;
  padding-left: 100%;
}

.userInfo_str > span {
  display: inline-block;
  padding-left: 100%;
}

.tokinaga {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 40px;
  height: 40%;
  color: #00aaff;
}

.menuContent {
  width: 100%;
  height: 66.5%;
  background-color: #e5e5e5;
}

.index {
  width: 100%;
  height: 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/index.vue